import {API} from 'aws-amplify';
import {awsApiName} from '../../shared/amplify/amplify-utils';
import {RequestBody} from '../../entity/core/request-body';
import {TitleSummaryRequest} from '../../entity/model/title-summary-request';

export default class TitleSummaryRequestAgent {

    createTitleSummaryRequest = async (organizationId: string, requestBody: RequestBody): Promise<TitleSummaryRequest> => {
        return await API.post(awsApiName, `/organizations/${organizationId}/title-summary-requests`, requestBody);
    }

    getTitleSummaryRequests = async (organizationId: string, titleId: string): Promise<TitleSummaryRequest[]> => {
        return await API.get(awsApiName, `/organizations/${organizationId}/title-summary-requests?projectTitleID=${titleId}`, {});
    }

    updateTitleSummaryRequest = async (organizationId: string, titleSummaryRequestId: string, requestBody: RequestBody): Promise<TitleSummaryRequest> => {
        return await API.patch(awsApiName, `/organizations/${organizationId}/title-summary-requests/${titleSummaryRequestId}`, requestBody);
    }
} 